import React from "react";
import { Dot } from "@phosphor-icons/react";
import { orderBy } from "lodash";
import { NavGroup } from "./NavGroup";
import { NavSection } from "./NavSection";
import { AppSectionNavGroupsProps } from "./types";
import { useLocation, useNavigate } from "react-router-dom";

export const AppSectionNavGroups: React.FC<AppSectionNavGroupsProps> = ({
  doToggle = () => null,
  openNavGroups = {},
  menuItems = [],
  type = "default",
}) => {
  // Subscribe to the router location so highlights update on client-side nav
  // (flat leaf icons navigate via <Link> without a full reload).
  const location = useLocation();
  const path = location.pathname;
  const navigation = useNavigate();

  return (
    <div data-testid="AppSectionNavGroups">
      {/* Render the "Apps" section */}
      {type === "default" && <NavSection>Apps</NavSection>}

      {/* Render the menu items */}
      {Boolean(menuItems) &&
        // Order the menu items based on order key
        orderBy(menuItems, ["order"], ["asc"]).map(
          ({ href, icon = null, label, children = [], badge }, key) => {
            return (
              <NavGroup
                key={key}
                icon={icon}
                href={href}
                badge={badge}
                name={label} //href.split("/")[1] + "=" + path.split("/")[1]}
                // isOpen={openNavGroups?.[label]}
                // Leaf items highlight on a precise path match so sibling screens
                // sharing a first segment (e.g. /agents/*) don't all light up at once.
                // Items with children keep the segment match so the parent stays
                // expanded across its sub-routes.
                isOpen={
                  path === href ||
                  path.startsWith(href + "/") ||
                  (Boolean(children.length) &&
                    href.split("/")[1] === path.split("/")[1])
                }
                onClick={() => window.location.href = href}
                type={type}
                items={
                  Boolean(children) && Boolean(children.length)
                    ? children.map(({ href, label, icon = <Dot /> }, key) => {
                        return {
                          href,
                          label,
                          icon,
                          isActive: path === href,
                        };
                      })
                    : []
                }
              />
            );
          }
        )}
    </div>
  );
};
